import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { PlatformSidebar } from "./PlatformSidebar";

export function PlatformLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider
      defaultWidth={280}
      minWidth={220}
      maxWidth={330}
      style={{ "--sidebar-width-icon": "4rem" } as React.CSSProperties}
    >
      <PlatformSidebar />
      <div className="flex-1 flex flex-col min-w-0 min-h-svh">
        <header className="md:hidden sticky top-0 z-30 flex items-center h-12 px-3 bg-background/95 backdrop-blur border-b">
          <SidebarTrigger />
        </header>
        <main className="flex-1 min-w-0 bg-background">
          <div className="mx-auto w-full max-w-[1800px]">{children}</div>
        </main>
      </div>
    </SidebarProvider>
  );
}
